import { Alert, Snackbar } from "@mui/material";

export default function MuiAlert(props: { error: boolean, message: string, open: boolean, onClose: CallableFunction }) {
    return (<Snackbar key={"top" + "center"} open={props.open} autoHideDuration={7000} onClose={() => { props.onClose() }}
        anchorOrigin={{ "vertical": "top", "horizontal": "center" }}>
        <Alert severity={props.error ? "error" : "success"} sx={{ width: '100%' }}>
            {props.message}
        </Alert>
    </Snackbar>)
}